import { IModuleMeta } from '@/contracts/core/module/interface/IModuleMeta'
import { IApi } from '@/contracts/core/api/interface/IApi'
import { IModuleSocket } from '@/contracts/core/module/interface/IModuleSocket'
import { EnumViewType } from '@/contracts/core/module/enum/EnumViewType'
import { IZone } from '@/contracts/system-modules/share/IZone'

export default class implements IModuleMeta {
  getCode(): string {
    return 'education'
  }
  registerApi(): IApi[] {
    return []
  }
  registerSocker(): IModuleSocket[] {
    return []
  }
  getZones(): IZone[] {
    return [{ code: 'education.questions', module: this.getCode(), title: 'Questions' }]
  }
  viewTypes(): EnumViewType[] {
    return [
      EnumViewType.WINDOW,
      EnumViewType.WIDGET,
    ]
  }

  getParentId(): string {
    return 'common'
  }

  getModuleId(): string {
    return this.getCode() + '_' + this.getVersion()
  }

  getTitle(): string {
    return 'Education'
  }

  getVersion(): string {
    return 'v1'
  }

  getIcon(): string {
    return 'flaticon-light-bulb'
  }
}
